// extracted by mini-css-extract-plugin
export default {"CardRailWithInventoryCardV2":"CardRailWithInventoryCardV2_CardRailWithInventoryCardV2__N2EzZ","callToActionButton":"CardRailWithInventoryCardV2_callToActionButton__ODNmO"};